import React, { useState } from "react";
import ShipmentsTable from "../ShipmentTable";
import SearchResultsBanner from "../../../../../components/ACS-Dashboard/ACS-Blocks/SearchResultsBanner";
// You can import other components here if you want additional subtabs

// Define the available subtabs and their corresponding components
const subTabConfigs = {
  shipments: {
    label: "Shipment List",
    component: ShipmentsTable,
  },
  // Example for another subtab (you can add more if needed)
  // details: {
  //   label: "Details",
  //   component: ShipmentDetailsComponent,
  // },
};

const ShipmentSearchSubTabs = ({
  searchQuery,
  searchTrigger,
  setTotalShipments,
  filter,
  stateKey = "shipment-search",
}) => {
  const [selectedSubTab, setSelectedSubTab] = useState("shipments");
  const currentSubTabConfig = subTabConfigs[selectedSubTab];

  return (
    <div className="w-full h-full flex flex-col">
      {/* Subtab navigation */}
      <div className="shrink-0 border-b border-gray-200">
        <div className="flex space-x-8">
          {Object.entries(subTabConfigs).map(([key, config]) => (
            <button
              key={key}
              onClick={() => setSelectedSubTab(key)}
              className={`px-1 py-4 text-sm font-medium ${
                selectedSubTab === key
                  ? "text-blue-600 border-b-2 border-blue-600"
                  : "text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }`}
            >
              {config.label}
            </button>
          ))}
        </div>
      </div>

      {/* Search info banner */}
      <SearchResultsBanner query={searchQuery} />
      {/* Subtab content */}
      <div className="h-full min-h-0 overflow-hidden flex flex-col">
        {currentSubTabConfig.component && (
          <currentSubTabConfig.component
            searchQuery={searchQuery}
            searchTrigger={searchTrigger}
            setTotalShipments={setTotalShipments}
            filter={filter}
            // Must match the bare stateKey the parent seeds advancedFilters/listViewState
            // under for this tab (see ShipmentDetails.handleSearch) — there's only one
            // subtab today, so there's nothing to disambiguate by suffixing it.
            stateKey={stateKey}
            showAdvancedFilters={false}
            isSearchTab

          />
        )}
      </div>
    </div>
  );
};

export default ShipmentSearchSubTabs;
